// extracted by mini-css-extract-plugin
module.exports = {"grid":"FolderGrid_grid__PCNT5"};